<template>
  <div class="myhome-header__button">
    <template v-if="role === 'ROLE_TEACHER' || role === 'ROLE_PRINCIPAL'">
      <h3 class="dea-heading--medium__m">
        Hai bisogno di assistenza? <br />
        Vuoi contattare la tua agenzia
      </h3>
      <Buttons
        class="dea-button--large dea-button--iconRight dea-button--inline "
        :href="agentsUrl"
        icon="richiedi-info"
        type="a"
        target="_blank"
      >
        Assistenza e agenzia
      </Buttons>
    </template>
    <template v-else-if="role === 'ROLE_GENERIC'">
      <h3 class="dea-heading--medium__m">
        Hai bisogno di assistenza?
      </h3>
      <Buttons
        class="dea-button--large dea-button--iconRight dea-button--inline "
        :href="agentsUrl"
        icon="richiedi-info"
        type="a"
        target="_blank"
      >
        FAQ e Assistenza
      </Buttons>
    </template>
    <template v-else>
      <h3 class="dea-heading--medium__m">
        Hai bisogno di aiuto?<br />
        Consulta la nostra Area Assistenza
      </h3>
      <Buttons
        class="dea-button--large dea-button--iconRight dea-button--inline "
        icon="richiedi-info"
        type="a"
        target="_blank"
        :href="$root.config.support_url"
      >
        Assistenza
      </Buttons>
    </template>
  </div>
</template>

<script>
import Buttons from "deascuola-storybook/src/components/elements/Buttons";

export default {
  name: "ButtonSupport",
  components: { Buttons },
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    role: {
      type: String,
      default: "ROLE_TEACHER",
    },
    agentsUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
